import { vnModule } from "../vnApp/vnModule";
import { vnApp } from "../vnApp/vn_app";
import { vn_app_zone_notification } from "./vn_app_zone_notification";
export class vnAppZone {
    get app() {
        return this._app;
    }
    set app(app) {
        this._app = app;
    }
    get lastLoadedModule() {
        return this._lastLoadedModule;
    }
    set lastLoadedModule(lastLoadedModule) {
        this._lastLoadedModule = lastLoadedModule;
    }
    get loadedModule() {
        return this._loadedModule;
    }
    set loadedModule(loadedModule) {
        this._loadedModule = loadedModule;
    }
    get routesActions() {
        return this._routesActions;
    }
    set routesActions(routesActions) {
        this._routesActions = routesActions;
    }
    get globals() {
        return this._globals;
    }
    set globals(globals) {
        this._globals = globals;
    }
    addGlobal(value) {
        for (var g = 0; g < this.globals.length; g++) {
            if (this.globals[g].index == value.index) {
                this.globals[g].value = value.value;
                return;
            }
        }
        this.globals.push(value);
    }
    removeGlobal(index) {
        for (var g = 0; g < this.globals.length; g++) {
            if (this.globals[g].index == index) {
                this.globals.splice(g, 1);
            }
        }
    }
    getGlobal(index) {
        for (var g = 0; g < this.globals.length; g++) {
            if (this.globals[g].index == index) {
                return this.globals[g].value;
            }
        }
        return null;
    }
    get notification() {
        return this._notification;
    }
    set notification(notification) {
        this._notification = notification;
    }
    get zoneName() {
        return this._zoneName;
    }
    set zoneName(zoneName) {
        this._zoneName = zoneName;
    }
    get destination() {
        return this._destination;
    }
    set destination(destination) {
        this._destination = destination;
    }
    constructor(destination) {
        this.zoneName = "undefined";
        this.destination = destination;
        this.routesActions = [];
        this.loadedModule = null;
        this.defineRoutes();
        this.isOnAlwaysReloadMode = false;
        this.globals = [];
    }
    //
    // add a function to execute for specific route
    addForRoute(route, loggedInFct, loggedOutFct) {
        this.routesActions[route] = [loggedInFct, loggedOutFct];
    }
    //
    // loaded the specifyed module
    // * only load module if its no the one already loaded
    loadModule(module) {
        if (module != null) {
            if (this.isOnAlwaysReloadMode || this.loadedModule == null || module.name != this.loadedModule.name || (this.app.loggedUser.lastIsLoggedIn != this.app.loggedUser.isLoggedIn)) {
                this.destination.className = "";
                this.destination.classList.add("loading");
                // load it
                module.load(this.destination);
                // keep it as loaded
                this.loadedModule = module;
                this.app.isLeavePageWarningNeeded = module.isLeavePageWarningNeeded;
                if (this.notification) {
                    this.showNotificationToModule();
                }
                else if (module.name == "home") {
                    //check permalink if it has error parameter, if it has it, check the code, and display the error using showNotificationToModule
                    let url = window.location.href;
                    let errorCode = url.split("redirected=")[1];
                    if (errorCode) {
                        let errorCodeMapping = {
                            1: "Redirected since the requested page does not exist."
                        };
                        let errorMessage = errorCodeMapping[errorCode];
                        if (errorMessage) {
                            this.notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, errorMessage);
                            let homeUrl = url.split('?')[0];
                            history.pushState({}, '', homeUrl);
                        }
                    }
                    this.showNotificationToModule();
                }
                // insert the module into the world !!! ( * rainbows and butterflies * )
                this.destination.classList.remove("loading");
                let nameClasses = this.loadedModule.name.split(" ");
                for (let nc of nameClasses) {
                    this.destination.classList.add(nc);
                }
                //This initializes the state of the app so when cancelling the back button it doesn't refresh the page
                this.moduleStateInitializer(this.app.isLeavePageWarningNeeded);
            }
        }
        else {
            this.destination.innerHTML = "";
        }
    }
    moduleStateInitializer(isLeavePageWarningNeeded) {
        if (isLeavePageWarningNeeded) {
            history.pushState(true, "unused argument", null);
            history.pushState(true, "unused argument2", null);
        }
    }
    addNotificationToModule(notification) {
        this.notification = notification;
    }
    showNotificationToModule() {
        if (this.notification) {
            let notificationDiv = document.createElement("div");
            notificationDiv.setAttribute('data-is-notification', 'true');
            notificationDiv.className = "zone-notification icon i-notice-" + this.notification.type + " " + this.notification.type;
            notificationDiv.innerHTML = "<div class='text'><strong>" + this.notification.type + "</strong><p>" + this.notification.message + "</p></div>";
            this.destination.insertBefore(notificationDiv, this.destination.firstChild);
            this.notification = null;
            this.deleteIn(4, notificationDiv);
        }
    }
    hideAllNotifications() {
        let allVisibleNotifications = document.querySelectorAll('[data-is-notification="true"]');
        for (let k of allVisibleNotifications) {
            this.deleteIn(0.1, k);
        }
    }
    showLoadingPopup() {
        this.hideLoadingPopup();
        let loadingDiv = document.createElement("div");
        loadingDiv.id = "loading-popup";
        loadingDiv.className = "w-loader";
        loadingDiv.innerHTML = "<div class='loader'></div>";
        this.destination.insertBefore(loadingDiv, this.destination.firstChild);
    }
    hideLoadingPopup() {
        let element = document.getElementById("loading-popup");
        if (element) {
            element.parentNode.removeChild(element);
        }
    }
    deleteIn(sec, element) {
        setTimeout(function () {
            try {
                element.parentNode.removeChild(element);
            }
            catch (e) {
                console.warn("couldn't remove the element, might be removed before");
            }
        }, sec * 1000);
    }
    //
    // Uses the  loaded module to inject it's content into
    // the specifyed destination
    setContent(content) {
        this.destination.innerHTML = "";
        this.destination.appendChild(content);
    }
    getApp() {
        return this._app;
    }
}
